import smartService from './smartService';

export * from './types';
export default smartService;



// WEBPACK FOOTER //
// ./src/services/smart/index.ts